import { emsMediumGrey } from "@electricMotorShop/EmsVariables";
import { AccordionContextData } from "@insite/mobius/Accordion/AccordionContext";
import AccordionSectionPanel from "@insite/mobius/AccordionSection/AccordionSectionPanel";
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import injectCss from "@insite/mobius/utilities/injectCss";
import MobiusStyledComponentProps from "@insite/mobius/utilities/MobiusStyledComponentProps";
import styled, { css } from "styled-components";

// XCentium override to change Accordion colors

export type AccordionSectionHeaderProps = MobiusStyledComponentProps<
    "dt",
    {
        /** Sets the initial expanded state of the section. */
        expanded?: boolean;
    } & InjectableCss &
        AccordionContextData,
    "headingLevel"
>;

const AccordionSectionHeader = styled.dt.attrs((props: AccordionSectionHeaderProps) => ({
    ariaLevel: props.headingLevel,
}))`
    background: ${getColor("common.background")};
    button {
        border: 0;
        border-top: 1px solid ${emsMediumGrey};
        border-radius: 0 !important;
        background: none;
        padding: 15px 0;
        height: 100%;
        width: 100%;
        font-family: inherit;
        display: flex;
        text-align: left;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;

        span {
            color: ${getColor("text.main")};
        }
    }
    ${/* sc-selector */ AccordionSectionPanel} + & button {
        padding: 17px 0 18px 0;
    }
    ${/* sc-selector */ IconWrapper}.toggle {
        ${({ expanded }: AccordionSectionHeaderProps) =>
            expanded
                ? css`
                      transform: rotate(180deg);
                  `
                : null}
    }
    ${injectCss}
`;

export default AccordionSectionHeader;
